import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { plurarize } from 'helpers/ContentHelper';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import Style from './UpsellBanner.module.scss';

class UpsellBanner extends Component {
  componentDidMount() {
    const { display, inline } = this.props;
    const showInfo = _.get(inline, 'items.member.0');
    const { upsellPromoTitle1, upsellPromoTitle2, upsellPromoButton } = window.Language;
    if (display && showInfo) {
      handleAnalytics({
        event: Events.BANNER_NOTIFICATION_IMPRESSION,
        payload: {
          page_message_title: `${upsellPromoTitle1} ${_.get(
            showInfo,
            'name',
          )} ${upsellPromoTitle2}`,
          page_message_text: this.getSubtitle(),
          page_message_type: upsellPromoButton,
        },
      });
    }
  }

  getSubtitle() {
    const { inline } = this.props;
    const fullEpisodeCount = _.get(inline, 'items.member.0.fullEpisodeCount', null);
    const seasonCount = _.get(inline, 'items.member.0.seasonCount', null);
    const {
      global_episodeButton: episodeLabel,
      global_episodesButton: episodesLabel,
      seriesDetail_seasonLabel: seasonLabel,
      seriesDetail_seasonsLabel: seasonsLabel,
    } = window.Language;
    const hasLabels = episodeLabel && episodesLabel && seasonLabel && seasonsLabel;
    if (!fullEpisodeCount || !seasonCount || !hasLabels) return null;
    const seasonText = plurarize({
      count: seasonCount,
      singular: seasonLabel,
      plural: seasonsLabel,
    });
    const episodeText = plurarize({
      count: fullEpisodeCount,
      singular: episodeLabel,
      plural: episodesLabel,
    });
    return `${seasonText} ${episodeText}`;
  }

  onBannerClick = e => {
    const { inline } = this.props;
    const { name } = _.get(inline, 'items.member.0');
    const { upsellPromoTitle1, upsellPromoTitle2, upsellPromoButton } = window.Language;
    handleAnalytics(
      {
        event: Events.UPGRADE_NOW_BUTTON_CLICKED,
        payload: {
          page_item_title: `${upsellPromoTitle1} ${name} ${upsellPromoTitle2}`,
          page_action_location: 'detail page',
        },
      },
      {
        event: Events.BANNER_NOTIFICATION_ACTION,
        payload: {
          page_message_title: `${upsellPromoTitle1} ${name} ${upsellPromoTitle2}`,
          page_message_text: this.getSubtitle(),
          page_message_type: upsellPromoButton,
          page_action_type: upsellPromoButton,
        },
      },
    );
    return null;
  };

  renderSubtitle() {
    return <small className={Style.subtitle}>{this.getSubtitle()}</small>;
  }

  render() {
    const { display, inline } = this.props;
    const showInfo = _.get(inline, 'items.member.0');
    const { upsellPromoTitle1, upsellPromoTitle2, upsellPromoButton } = window.Language;
    const hasLabels = upsellPromoTitle1 && upsellPromoTitle2 && upsellPromoButton;
    if (!display || !showInfo || !hasLabels) return null;
    const { name } = showInfo;
    return (
      <div className={Style.container} data-test="upsell-banner">
        <strong
          className={Style.title}
        >{`${upsellPromoTitle1} ${name} ${upsellPromoTitle2}`}</strong>
        {this.renderSubtitle()}
        <button onClick={e => this.onBannerClick(e)} className={Style.button} type="button">
          {upsellPromoButton}
        </button>
      </div>
    );
  }
}

UpsellBanner.defaultProps = {
  display: false,
  inline: {},
};

UpsellBanner.propTypes = {
  display: PropTypes.bool,
  inline: PropTypes.shape({}),
};

export default UpsellBanner;
